import { Box } from '@mui/material';
import { useContext } from 'react';
import { SlidePreviewContext } from '../../lessons/contexts/SlidePreviewContext';
import { SlideComponent, SlideComponentImage } from 'models/lesson/LessonModel';

export const SlideImage = ({ item }: { item: SlideComponent; index: number }) => {
    const { zoom } = useContext(SlidePreviewContext);

    let itemContent: SlideComponentImage = item.content as SlideComponentImage;

    return (
        <Box
            component='img'
            src={`/asset/images/${itemContent.filename || 'default.png'}`}
            alt='bg'
            sx={{
                position: 'absolute',
                zoom: zoom,
                aspectRatio: 'auto',
                transform: `scaleX(${itemContent.flip ?? 1})`,
                pointerEvents: 'none',
                left: item.pos.x,
                top: item.pos.y,
                zIndex: itemContent.zIndex,
                m: 'inherit',
                p: 'inherit',
            }}
            width={item.size.width}
        />
    );
};
